<template>

  <!-- Slides Gallery Content -->
  <div
    class="slides-gallery-content"
    :class="{'is-fullscreen': isFullscreen}">

    <q-responsive
      :ratio="ratio">

      <q-carousel
        animated
        swipeable
        v-model="carousel"
        transition-next="slide-left"
        transition-prev="slide-right"
        prev-icon="fa lni-chevron-left"
        next-icon="fa lni-chevron-right"
        :arrows="value.elements.length > 1">

        <slides-gallery-element
          :key="index"
          :name="index"
          :value="element"
          v-for="(element, index) in value.elements"/>

      </q-carousel>

    </q-responsive>

  </div>

</template>

<script>

  import SlidesGalleryElement from '@src/components/element/slides-gallery-element';

  export default {
    name: 'slides-gallery-content',
    props: {
      value: {
        type: Object,
        required: true,
      },
      isFullscreen: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      SlidesGalleryElement,
    },
    computed: {
      ratio() {

        if (this.$q.screen.lt.sm)
          return 10 / 16;

        if (this.$q.screen.lt.md)
          return 1;

        return 16 / 9;
      },
    },
    data() {
      return {
        carousel: 0,
      };
    },
  };

</script>

<style lang="scss">

  .slides-gallery-content {
    color: inherit;

    .q-carousel,
    .q-responsive {
      max-height: 80vh;
      min-height: 500px;
    }

    .q-carousel {
      background: transparent;
      border-radius: $card-radius;

      @media (min-width: $breakpoint-md) {
        max-height: 100% !important;
      }
    }

    &.is-fullscreen {

      .q-carousel {
        border-radius: 0;
      }

      .q-carousel,
      .q-responsive {
        min-height: 100vh !important;
        max-height: 100vh !important;
      }
    }

    .q-panel {
      overflow: hidden;
    }

    @media (max-width: $breakpoint-sm) {

      .q-carousel__arrow {
        display: none;
      }
    }

    .q-carousel__arrow button {
      opacity: .7;
      padding: .4rem;
      transition: opacity .2s linear;
    }

    .q-carousel:hover .q-carousel__arrow button {
      opacity: 1;
    }

    .q-carousel__prev-arrow {
      left: 1rem;
    }

    .q-carousel__prev-arrow i {
      left: -3px;
    }

    .q-carousel__next-arrow {
      right: 1rem;
    }

    .q-carousel__next-arrow i {
      right: -3px;
    }

    .q-carousel__prev-arrow i,
    .q-carousel__next-arrow i {
      color: white;
      font-size: 38px;
    }
  }

</style>
